import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { loginIntial } from "../../features/auth/authSlice";
import { useEffect, useRef } from "react";
import Header from "./Header";
import { clearObj, setActiveObj } from "../../features/obj/objSlice";
import toast from "react-hot-toast";
import RightSide from "./RightSide";
import svg76 from "../../assets/svg/svg76.svg";
import svg77 from "../../assets/svg/svg77.svg";
import { getInitials } from "../../utils";

export default function SelectOrganization() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { accountInfo } = useSelector((state) => state.auth);
  const { subdomain } = useSelector((state) => state.global);
  const formRef = useRef(null);
  const onFinish = async (data) => {
    const res = await dispatch(loginIntial(data));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await navigate("/login-otp");
    } else {
      toast.error(res?.payload?.messages?.message ?? "Invalid Credentials");
    }
  };

  const handleRegister = async () => {
    await dispatch(clearObj());
    await navigate("/registration");
  };

 
  const handleClick = async (item) => {
    await dispatch(setActiveObj(item));
    await navigate("/login-password");
  };
 
  useEffect(() => {
    if (accountInfo?.userEmail) {
      form.setFieldsValue({
        userEmail: accountInfo?.userEmail,
      });
    }
  }, [accountInfo, form]);
  return (
    <div className="overflow-y-auto min-h-screen h-screen w-full">
      <div className="flex w-full  min-h-screen bg-white ">
        <div className="flex flex-col w-full ">
          <Header />
          <div className="w-full h-full flex flex-col justify-center items-center">
            <div className="w-full max-w-[32.25rem] flex flex-col lg:px-0 px-3">
              <span
                className={`heading_1 ${
                  subdomain === "ndovupay" || subdomain === "localhost"
                    ? "!text-[#DB2A12]"
                    : "text-inherit"
                }`}
              >
                Select Organization
              </span>
              <span className="paragraph_1 mt-[1.13rem]">
                Please choose an organization you want to proceed with
              </span>

              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "2.06rem",
                  width: "100%",
                }}
                form={form}
              >
                <Form.Item
                  name="userEmail"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required to login",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <Input
                    readOnly
                    prefix={<img src={svg77} alt="svg77" />}
                    type="email"
                    className="input"
                  />
                </Form.Item>

                <div className="mt-[2.5rem]">
                  {accountInfo?.organizations &&
                    accountInfo?.organizations?.map((item) => (
                      <div
                        onClick={() => handleClick(item)}
                        className="group border border-[#E5E7EB] hover:border-[#FFB600] rounded-[1rem] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] py-[1.5rem] px-[2rem] mb-[1.25rem] cursor-pointer transition-colors duration-200"
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex gap-[1rem]">
                            <div className="w-[2.8125rem] h-[2.8125rem] rounded-full bg-[#FFB600]/10 text-[#FFB600] text-[1.125rem] font-[400] leading-[1.575rem] flex items-center justify-center">
                              {getInitials(item?.orgName)}
                            </div>
                            <div className="flex flex-col">
                              <div className="text-[#111827] text-[1rem] font-[400] leading-normal">
                                {item?.orgName}
                              </div>
                              <div className="flex items-center gap-[.5rem] text-[#4B5563] text-[.875rem] font-[300] leading-normal">
                                <span>
                                  {item?.industryName ?? "Organization"}
                                </span>
                                <span>•</span>
                                <span>{item?.orgCode}</span>
                              </div>
                            </div>
                          </div>

                          <div className="w-[1.5rem] h-[1.5rem] rounded-full bg-[#FFB600]/10 items-center justify-center hidden group-hover:flex">
                            <img src={svg76} alt="svg76" />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="w-full justify-center flex mt-[2.5rem]">
                  <span className="label_2 !text-[#0A0A0A]">
                    Don’t have an account?{" "}
                  </span>
                  <button
                    type="button"
                    className=" label_2 !text-[#DB2A12] ml-[.1rem]"
                    onClick={handleRegister}
                  >
                    Register
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>

        <RightSide />
      </div>
    </div>
  );
}
